/**
 * Utility to uses clsx and twMerge
 * - removes conflicting classes
 * - Trims whitespace
 * - Deduplicates classes
 * - add logic options
 *
 * Strings (variadic)
 *  clsx('foo', true && 'bar', 'baz');
 *  => 'foo bar baz'

 * Objects
 *  clsx({ foo:true, bar:false, baz:isTrue() });
 *  => 'foo baz'
 *
 * Objects (variadic)
 *  clsx({ foo:true }, { bar:false }, null, { '--foobar':'hello' });
 *  => 'foo --foobar'
 *
 * Arrays
 *  clsx(['foo', 0, false, 'bar']);
 *  => 'foo bar'
 *
 * Arrays (variadic)
 *  clsx(['foo'], ['', 0, false, 'bar'], [['baz', [['hello'], 'there']]]);
 *  => 'foo bar baz hello there'
 *
 * @example
 * tw(
 *   'invisible absolute top-[40px]',
 *   'flex border-0 p-0',
 *   {'opacity-100': isOpen, 'opacity-0': !isOpen},
 * )
 *
 * @param {ReadonlyArray<string>} classes - Array of Tailwind CSS class strings
 * @returns {string} - Combined class string
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const tw = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
